import { FieldOrigin, InputType, IVisibleProp } from 'config'
import { normalizeCoborrowerRequiredRecord } from 'config/borrowerFieldRequired.util'
import { BorrowerSeperator } from 'pages/LoanApplication/config'
import { useMemo, useState } from 'react'
import { Modal } from 'stories/components'

import { CoborrowerRequiredByBorrowerFields } from './CoborrowerRequiredByBorrowerFields'

type Props = {
  fieldOrigin: FieldOrigin
  fieldKey: string
  itemData: IVisibleProp
  input: InputType
  onClose: () => void
  onSave: (fieldOrigin: FieldOrigin, fieldKey: string, next: IVisibleProp) => void
}

export const CoborrowerRequiredModal = ({ itemData, fieldOrigin, fieldKey, input, onClose, onSave }: Props) => {
  const primaryRequired = itemData.required === undefined ? !!input.required : !!itemData.required
  const initial = useMemo(
    () => normalizeCoborrowerRequiredRecord(itemData.coborrowerRequired, primaryRequired),
    [itemData.coborrowerRequired, primaryRequired, fieldKey, fieldOrigin],
  )
  const [draft, setDraft] = useState<Record<BorrowerSeperator, boolean>>(initial)

  return (
    <Modal
      isOpen
      title="Required by borrower"
      titleOkay="Save"
      onClose={onClose}
      onOk={() => {
        onSave(fieldOrigin, fieldKey, {
          ...itemData,
          required: draft[BorrowerSeperator.BORROWER],
          coborrowerRequired: draft,
        })
        return true
      }}
    >
      <div className="w-96 max-w-full">
        <CoborrowerRequiredByBorrowerFields
          value={draft}
          primaryRequired={draft[BorrowerSeperator.BORROWER]}
          onChange={(rec) => setDraft(rec)}
        />
        <p className="mt-3 text-xs text-gray-500">
          Select which of the up to eight borrowers must complete this field.
        </p>
      </div>
    </Modal>
  )
}
